import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Award } from "lucide-react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BadgeCard } from "./components/BadgeCard";

interface Badge {
  id: string;
  name: string;
  description: string;
  image_url: string | null;
  badge_type: string;
}

interface UserBadge {
  badges: Badge;
}

export const BadgesSection = () => {
  const { data: allBadges } = useQuery({
    queryKey: ["badges"],
    queryFn: async () => {
      const { data } = await supabase
        .from("badges")
        .select("*")
        .order("badge_type");
      return data || [];
    },
  });

  const { data: userBadges } = useQuery({
    queryKey: ["user-badges"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return [];

      const { data } = await supabase
        .from("user_badges")
        .select(`
          badges (
            id,
            name,
            description,
            image_url,
            badge_type
          )
        `)
        .eq("user_id", user.id);

      return data as UserBadge[];
    },
  });

  if (!allBadges) {
    return null;
  }

  const earnedBadgeIds = new Set(userBadges?.map(ub => ub.badges.id));

  return (
    <section className="px-4 sm:px-4 py-6 border-b border-black/10 dark:border-white/10">
      <div className="mx-auto max-w-4xl">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <Award className="w-5 h-5 text-primary dark:text-clubbers-blue ocean:text-ocean sunset:text-sunset forest:text-forest" />
          Tus Logros
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          <TooltipProvider delayDuration={200}>
            {allBadges.map((badge) => (
              <BadgeCard 
                key={badge.id}
                badge={badge}
                isEarned={earnedBadgeIds.has(badge.id)}
              />
            ))}
          </TooltipProvider>
        </div>
      </div>
    </section>
  );
};